angular.module('tgaAdmin').controller('ScormUploadController', [
  '$scope',
  '$state',
  '$window',
  '$uibModalInstance',
  '$uibModalStack',
  'scormService',
  'extras',
  '$translate',
  '$timeout',
  'settingsService',
  function (
    $scope,
    $state,
    $window,
    $uibModalInstance,
    $uibModalStack,
    scormService,
    extras,
    $translate,
    $timeout,
    settingsService,
  ) {
    $scope.data = {
      alerts: [],
      settings: {},
      hubId: extras.hubId,
      disable_featured: extras.items_featured >= 3,
      package_types: [
        {
          id: 'scorm',
          name: 'game.scorm',
        },
        {
          id: 'xapi',
          name: 'game.xapi',
        },
      ],
    };

    $scope.viewmodel = {
      name: null,
      file: null,
      hub_activity_id: null, // for existing tasks
      hub_id: $scope.data.hubId,
      activity_type: 'game',
      is_external: true,
      show_solo: true,
      show_challenge: false,
      show_leaderboard: false,
      tile_image: null,
      tile_color: null,
      data: null,
      data_type: null,
      start_date: null,
      end_date: null,
      coming_soon: null,
      is_featured: null,
      featured_text: null,
      package_type: 'scorm',
      xapi_endpoint: null,
      xapi_key: null,
      xapi_secret: null,
      xapi_launch_file: null,
    };

    $scope.initialize = function () {
      $scope.data.package_types.forEach((type) => {
        type.name = $translate.instant(type.name).toString();
        return type;
      });

      settingsService.getSettings().then((settings) => {
        $scope.data.settings = settings;
      });
    };

    $scope.actions = {
      submit(form) {
        if (form.$invalid || !$scope.viewmodel.file) {
          return;
        }

        if (!$scope.viewmodel.file.$error) {
          $scope.loading = true;
          $uibModalStack.getTop().value.backdrop = 'static';
          $uibModalStack.getTop().value.keyboard = false;
          let xapi_auth = null;

          if ($scope.viewmodel.package_type === 'xapi') {
            xapi_auth = `Basic ${btoa(`${$scope.viewmodel.xapi_key}:${$scope.viewmodel.xapi_secret}`)}`;
          }

          scormService
            .upload({
              hub_id: $scope.data.hubId,
              name: $scope.viewmodel.name,
              package_type: $scope.viewmodel.package_type,
              xapi_endpoint: $scope.viewmodel.xapi_endpoint,
              xapi_launch_file: $scope.viewmodel.xapi_launch_file,
              xapi_auth,
              files: [$scope.viewmodel.file],
            })
            .then((resp) => {
              $scope.loading = false;
              delete $scope.viewmodel.name;
              delete $scope.viewmodel.file;
              const data = { ...$scope.viewmodel, ...resp.data };
              $uibModalInstance.close(data);
            })
            .catch((error) => {
              $scope.loading = false;
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
            });
        }
      },
      checkImage(image) {
        $scope.actions.clearAlerts();

        if (!image) {
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        const extension = /(?:\.([^.]+))?$/;
        const ext = extension.exec(image.filename)[1];
        const allowed = /jpeg|jpg|gif|png|svg|pdf|mpg|mpeg|mp4|avi/i;
        if (!allowed.test(ext)) {
          $scope.viewmodel.data = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        // Don't allow images larger than 10MB.
        if (image.filesize > 10485760) {
          $scope.viewmodel.data = null;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Image files cannot be more than 10 MB in size.',
            'danger',
          );
        }
      },
      forceHex() {
        if ($scope.viewmodel.tile_color[0] !== '#') {
          $scope.viewmodel.tile_color = `#${$scope.viewmodel.tile_color}`;
        }
      },
      videoEmbed(item) {
        if (item.data.includes('vimeo')) {
          const result = item.data.match(
            // eslint-disable-next-line max-len, no-useless-escape
            /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i,
          );
          item.data = `https://player.vimeo.com/video/${result[1]}`;
        } else if (item.data.includes('youtu')) {
          if (!item.data.includes('embed')) {
            const expr = /(youtu\.be\/|[?&]v=)([^&]+)/;
            item.data = `https://www.youtube.com/embed/${item.data.match(expr)[2]}`;
          }
        }
      },
      changePackageType() {
        if ($scope.viewmodel.package_type === 'xapi') {
          $timeout(() => {
            $scope.activeTab = 0;
          }, 0);
        } else {
          $scope.activeTab = 1;
        }
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      clearAlerts() {
        $scope.data.alerts = [];
      },
      close() {
        $uibModalInstance.dismiss();
      },
    };
    $scope.initialize();
  },
]);
